import { Flex, Spinner } from '@servicetitan/anvil2';
import { FC } from 'react';

export const PageLoading: FC = () => {
    return (
        <Flex
            justifyContent="center"
            alignItems="center"
            direction="column"
            className="p-block-start-14"
        >
            <Spinner style={{ width: 'var(--a2-size-8)', height: 'var(--a2-size-8)' }} />
        </Flex>
    );
};
